export default "__VITE_ASSET__fa0309b7__"